import { useQuery } from '@apollo/client';
import type { UseLalSegmentFetchResponse } from '@openx/components-segment/lib/utils/context/SegmentHookTypes.ts';
import { GetLalSegmentDocument } from '../../../graphql/query/segments/lal/GetLalSegment.generated.tsx';

export const useLalSegmentFetch = (id: string): UseLalSegmentFetchResponse => {
  const { data, loading, error, refetch } = useQuery(GetLalSegmentDocument, {
    skip: !id,
    variables: { id },
  });

  return { lalSegment: data?.lalSegment, loading, error, refetch };
};
